import { render, staticRenderFns } from "./MpTextarea.vue?vue&type=template&id=2623f6a1"
import script from "./MpTextarea.vue?vue&type=script&lang=ts"
export * from "./MpTextarea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports